import React, { useState } from "react";
import { useRouter } from "next/router";
// @ts-ignore
import { Document, Page, pdfjs } from "react-pdf";
import { Wrapper } from "./style";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ReferenceByToken = () => {
  const router = useRouter();
  const token = router?.query?.id;
  const [numPages, setNumPages] = useState<number | null>(null);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <Wrapper>
      <Document
        file={`/api/reference?token=${token}`}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page
          pageNumber={1}
          numPages={numPages}
          renderTextLayer={false} // Hides the text layer
          renderAnnotationLayer={false} // Hides the annotation layer
        />
      </Document>
    </Wrapper>
  );
};

export default ReferenceByToken;
